<button
    class="scroll-to-top"
    lsUiButtonKind="basic"
    lsUiButtonPalette="neutral-1"
    lsUiButtonSize="small"
    lsUiScrollToTop
    [hasIcon]="true"
    [name]="'common.button-to-top' | translate"
>
    <ls-ui-icon
        class="scroll-to-top__icon"
        height="24"
        src="chevron"
        width="24"
    />
</button>
